<template>
  <div>
    <error v-if="!hasPermissions" :error="error"/>
    <slot v-if="hasPermissions"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Error from './Error.vue'

export default {
  components: { Error },
  props: ['roles'],
  computed: {
    ...mapGetters([
      'oidcUser'
    ]),
    usersRoles () {
      return this.oidcUser.role
    },
    missingRoles () {
      return this.roles.filter(r => this.usersRoles.indexOf(r) === -1)
    },
    hasPermissions () {
      return this.missingRoles.length === 0
    },
    error () {
      const displayMissingRoles = this.missingRoles.map(r => `'${r}'`)
      return `You are missing the following roles to view this page: ${displayMissingRoles}`
    }
  }
}
</script>
